<ng-container *ngFor="let essential of essentials(); let last = last" [ngSwitch]="essential.code">
    <ng-template #lineOut let-line>
        <div mulo-page-line *ngIf="line">{{ line | htmlStrip }}</div>
    </ng-template>
    <ng-template [ngSwitchCase]="'partOf'">
        <ng-container
            *ngTemplateOutlet="lineOut; context: { $implicit: fullAssetPageRep.publicationDetailsLine }"
        ></ng-container>
    </ng-template>
    <ng-template [ngSwitchCase]="'series'">
        <ng-container
            *ngTemplateOutlet="lineOut; context: { $implicit: fullAssetPageRep.seriesDetailsLine }"
        ></ng-container>
    </ng-template>
    <ng-template [ngSwitchCase]="'conference'">
        <ng-container
            *ngTemplateOutlet="lineOut; context: { $implicit: fullAssetPageRep.conferenceDetailsLine }"
        ></ng-container>
    </ng-template>
    <ng-template [ngSwitchCase]="'event'">
        <ng-container
            *ngTemplateOutlet="lineOut; context: { $implicit: fullAssetPageRep.eventDetailsLine }"
        ></ng-container>
    </ng-template>
    <ng-template [ngSwitchCase]="'etd'">
        <ng-container
            *ngTemplateOutlet="lineOut; context: { $implicit: fullAssetPageRep.etdDetailsLine }"
        ></ng-container>
    </ng-template>
</ng-container>
<div mulo-page-line *ngIf="fullAssetPageRep?.date">{{ fullAssetPageRep?.date }}</div>

<ng-container *ngIf="isAvailableIdentifiersToDisplay()">
    <ng-container *ngFor="let identifier of getAvailableIdentifiersToDisplay()">
        <div *ngIf="isLink(assetsIdentifiersToDisplay[identifier])" mulo-page-line>
            {{
                'esploro.research.conf.research.portal.label.prefix.esploroAssetModel.identifiers.' + identifier
                    | translate
            }}:
            <a
                *ngIf="isDoiOrHandleExternal(identifier)"
                [href]="assetsIdentifiersToDisplay[identifier]"
                target="_blank"
                style="word-break: break-all"
            >
                {{ assetsIdentifiersToDisplay[identifier] }}
            </a>
            <div *ngIf="!isDoiOrHandleExternal(identifier)" style="display: inline-block">
                {{ assetsIdentifiersToDisplay[identifier] }}
            </div>
        </div>

        <div mulo-page-line *ngIf="!isLink(assetsIdentifiersToDisplay[identifier])">
            {{
                'esploro.research.conf.research.portal.label.prefix.esploroAssetModel.identifiers.' + identifier
                    | translate
            }}: {{ assetsIdentifiersToDisplay[identifier][0] }}
        </div>
    </ng-container>
</ng-container>
